import {HttpClient, HttpHeaders} from '@angular/common/http';
import { Service, inject } from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {EntityKey} from '../entity/entity';
import {Specification} from '../entity/specification';
import {SpecificationCharacteristic} from '../entity/specification-characteristic';
import {GoogleService} from './google-service';

@Service()
export class SpecificationService {
  private readonly http = inject(HttpClient);
  private readonly googleService = inject(GoogleService);


  private urlBase = environment.serviceUrl;

  getSpecifications(id: EntityKey): Observable<Specification[]> {
    const url: string = this.urlBase + 'specifications/' + id.entityId + '/' + id.entityRevision;
    return this.http.get<Specification[]>(url, {headers: this.getRequestHeaders()});
  }

  private getRequestHeaders(): HttpHeaders {
    return new HttpHeaders().set(GoogleService.TokenHeader, this.googleService.getAccessToken());
  }

  saveProjectDefaults(id: EntityKey, characteristics: SpecificationCharacteristic[]): Observable<string> {
    const url: string = this.urlBase + 'specifications/projectDefaults/' + id.entityId + '/' + id.entityRevision;
    const body: string = JSON.stringify(characteristics);
    return this.http.post(url, body, {headers: this.getPostHeaders(), responseType: 'text'});
  }

  private getPostHeaders(): HttpHeaders {
    return this.getRequestHeaders().set("Content-Type", "application/json");
  }

}
